// Dependencies
var Backbone = require('backbone');
var Radio = require('backbone.radio');
var moment = require('moment');

// App
var DeferModel = require('app/utils/defer-entity');
var EntitiesAPI = require('app/utils/entities').EntitiesAPI;
const { listingsUrl } = require('app/react-app/apps/buildings/api');

// Channels
var publicChannel = Radio.channel('public');

var PublicListing = Backbone.Model.extend({
    defaults: {
        urlArgs: [],
        queryString: '',
    },
    url: function() {
        return '/p/listing/' + this.get('urlArgs').join('/') + '.json' + this.get('queryString');
    },
});

var PublicBuilding = Backbone.Model.extend({
    defaults: {
        urlArgs: [],
        queryString: '',
    },
    url: function() {
        return '/p/building/' + this.get('urlArgs').join('/') + '.json' + this.get('queryString');
    },
});

var ClientFeedback = Backbone.Model.extend({
    url: function() {
        var modelType = null,
            modelId = null;
        var clientListingId = this.get('client_listing_id');
        if (!clientListingId) {
            return null;
        }
        if (this.get('building_id')) {
            modelType = 'building';
            modelId = this.get('building_id');
        } else {
            modelType = 'unit';
            modelId = this.get('unit_id');
        }

        var agentId = this.get('agent_id');
        var agentParam = agentId ? `?agent=${agentId}` : '';

        return `/api/internal/clients/clientlistings/${clientListingId}/${modelType}/${modelId}/client-feedback/${agentParam}`;
    },
});

var BuildingListing = Backbone.Model.extend({
    defaults: {
        layout: null,
        square_footage: null,
        bathrooms: null,
        price: null,
        unit_number: null,
        status: null,
        listing_type: null,
        private: null,
        last_listed_at: null,
        status_updated: null,
        is_company_listing: null,
        closed_price: null,
        closed_date: null,
        listing_company: null,
    },
    latestUpdate: function() {
        return this.get('closed_date') || this.get('status_updated');
    },
});

var BuildingListings = Backbone.Collection.extend({
    model: BuildingListing,
    comparator: function(modelA, modelB) {
        if (modelA.get('is_company_listing') && !modelB.get('is_company_listing')) {
            return -1;
        } else if (!modelA.get('is_company_listing') && modelB.get('is_company_listing')) {
            return 1;
        } else if (moment(modelA.latestUpdate()).isAfter(modelB.latestUpdate())) {
            return -1;
        } else if (moment(modelA.latestUpdate()).isBefore(modelB.latestUpdate())) {
            return 1;
        }

        return 0;
    },
    initialize: function(models, options) {
        this.buildingId = options.buildingId;
    },
    url: function() {
        return listingsUrl(this.buildingId);
    },
});

var API = EntitiesAPI.extend({
    channel: publicChannel,
    replyPublicListing: function(args, queryString) {
        var listingDefer = new DeferModel(PublicListing);

        return listingDefer.defer({
            entityAttributes: {
                urlArgs: args,
                queryString: queryString,
            },
        });
    },
    replyPublicBuilding: function(args, queryString) {
        var buildingDefer = new DeferModel(PublicBuilding);

        return buildingDefer.defer({
            entityAttributes: {
                urlArgs: args,
                queryString: queryString,
            },
        });
    },
});

module.exports = {
    API: API,
    BuildingListing: BuildingListing,
    BuildingListings: BuildingListings,
    ClientFeedback: ClientFeedback,
    PublicListing: PublicListing,
    PublicBuilding: PublicBuilding,
};
